<template>
    <template
        v-for="(post, index) in posts"
        :key="post.id">
        <template v-if="showAds && (index + 7) % 10 === 0">
            <Ad
                :category="category"
                :index="adIndex(index)" />
        </template>
        <PostListItem
            v-intersect="(isIntersecting: boolean) => onIntersect(isIntersecting, index)"
            :category="category"
            class="tw-px-0"
            :post="post" />
        <v-divider
            v-if="post !== posts[posts.length - 1]"
            class="tw-my-5"
            opacity="0.1"></v-divider>
    </template>
</template>

<script setup lang="ts">
    import type { Category } from '@/configs/categories';
    import type { WPPost } from '@/contentTypes';

    const props = defineProps<{
        posts: WPPost[];
        category?: Category;
        showAds?: boolean;
    }>();

    const emit = defineEmits<{
        (e: 'fetch-more'): void;
    }>();

    const adIndex = (postIndex: number) => {
        return Math.floor(postIndex / 10);
    };

    function onIntersect(isIntersecting: boolean, index: number) {
        if (isIntersecting && index === props.posts.length - 5) {
            emit('fetch-more');
        }
    }
</script>

<style lang="scss"></style>
